<template>
  <div class="d-grid gap-4">
    <div class="row g-3">
      <div
        v-for="card in builder_summary_cards"
        :key="card.label"
        class="col-12 col-md-6 col-xl"
      >
        <div class="card border rounded-lg p-3 shadow-sm h-100 bg-light">
          <p class="text-uppercase text-muted text-xxs mb-1">{{ card.label }}</p>
          <p class="fw-bold text-dark text-xxs mb-1">{{ card.value }}</p>
          <p class="text-muted text-xxs mb-0">{{ card.description }}</p>
        </div>
      </div>
    </div>

    <div class="card border rounded-lg p-3 shadow-sm bg-light">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-3">
        <p class="text-uppercase text-muted text-xxs mb-0">{{ translate_label("Layout preview") }}</p>
        <span class="text-muted text-xxs">{{ layout_preview_text }}</span>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <span
          v-for="field in preview_columns"
          :key="field.id"
          class="badge bg-white text-dark text-xxs rounded-small shadow-sm px-3 py-2"
        >
          {{ get_preview_column_label(field) }}
        </span>
      </div>
    </div>

    <div class="card border rounded-lg p-3 shadow-sm bg-light">
      <p class="fw-bold text-dark text-xxs mb-1">{{ translate_label("Generate") }}</p>
      <p class="text-muted text-xxs mb-0">
        {{
          save_as_template
            ? translate_label("The template is saved first, then the selected output is generated and uploaded immediately.")
            : translate_label("A one-off configuration is stored for history only, then the selected output is generated and uploaded immediately.")
        }}
      </p>
    </div>

    <div v-if="generated_report" class="card border rounded-lg p-3 shadow-sm bg-light">
      <p class="fw-bold text-dark text-xxs mb-1">{{ generated_report.name }}</p>
      <p class="text-muted text-xxs mb-2">
        {{ translate_label("Status") }}: {{ generated_report.status?.display_name || translate_label("Completed") }}
      </p>
      <a
        v-if="generated_report.presigned_url"
        :href="generated_report.presigned_url"
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
        rel="noopener noreferrer"
        target="_blank"
      >
        {{ translate_label("Download report") }}
      </a>
      <p v-else-if="generated_report.error_message" class="text-danger text-xxs mb-0">
        {{ generated_report.error_message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "report_builder_review_step",
  props: {
    builder_summary_cards: { type: Array, required: true },
    generated_report: { type: Object, default: null },
    get_preview_column_label: { type: Function, required: true },
    layout_preview_text: { type: String, required: true },
    preview_columns: { type: Array, required: true },
    save_as_template: { type: Boolean, required: true },
    translate_label: { type: Function, required: true },
  },
};
</script>
